import { useState, useEffect, useRef } from "react";
import { BaseNode } from "./baseNode";

export const TextNode = ({ id, data }) => {
  const [text, setText] = useState(data?.text || "{{input}}");
  const [variables, setVariables] = useState([]);

  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }

    const regex = /{{\s*([a-zA-Z_$][a-zA-Z0-9_$]*)\s*}}/g;
    const matches = [...text.matchAll(regex)];
    const uniqueVars = [...new Set(matches.map((m) => m[1]))];
    setVariables(uniqueVars);
  }, [text]);

  const leftHandles = variables.map((variable, index) => ({
    id: `${id}-${variable}`,
    top: `${30 + index * 20}%`,
    label: variable
  }));

  const handleChange = (e) => {
    setText(e.target.value);
  };

  return (
    <BaseNode
      id={id}
      title="Text"
      leftHandles={leftHandles}
      rightHandles={[{ id: `${id}-output`, top: "50%", label: "Text" }]}
      width={260}
    >
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
          Text
        </label>
        <textarea
          ref={textareaRef}
          value={text}
          onChange={handleChange}
          onInput={(e) => {
            e.target.style.height = "auto";
            e.target.style.height = e.target.scrollHeight + "px";
          }}
          placeholder="Type text with {{variables}}"
          className="nodrag w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all font-medium text-gray-700 dark:text-gray-200 resize-none overflow-hidden min-h-[40px]"
        />
      </div>
    </BaseNode>
  );
};
